module.exports = __webpack_public_path__ + "img/logo-words.d47c888f.svg";